import axios, { AxiosRequestConfig } from 'axios';

const NetworkApi = {
  getDefaultHeaders: () => {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };
  },

  getHeaders: () => {
    const headers = {
      ...NetworkApi.getDefaultHeaders()
    };
    return headers;
  },

  get: (route: any, headers: any) => {
    return new Promise((resolve, reject) => {
      NetworkApi.prepareConfig(
        route,
        null,
        'get',
        headers,
        (err: any, res: unknown) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(res);
        }
      );
    });
  },
  post: (route: any, params: any, headers: any) => {
    return new Promise((resolve, reject) => {
      NetworkApi.prepareConfig(
        route,
        params,
        'post',
        headers,
        (err: any, res: unknown) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(res);
        }
      );
    });
  },
  put: (route: any, params: any, headers: any) => {
    return new Promise((resolve, reject) => {
      NetworkApi.prepareConfig(
        route,
        params,
        'put',
        headers,
        (err: any, res: unknown) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(res);
        }
      );
    });
  },
  delete: (route: any, params: any, headers: any) => {
    return new Promise((resolve, reject) => {
      NetworkApi.prepareConfig(
        route,
        null,
        'delete',
        headers,
        (err: any, res: unknown) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(res);
        }
      );
    });
  },
  prepareConfig: async (
    url: any,
    data: any,
    methodType: any,
    headers: any,
    callback: any
  ) => {
    const config = {
      method: methodType,
      url,
      data,
      headers: headers || NetworkApi.getDefaultHeaders()
      // timeout: NetworkApi.requestTimeout
    };
    NetworkApi.call(config, callback);
  },
  call: (
    config: AxiosRequestConfig<any>,
    callback: (arg0: null, arg1: null) => void
  ) => {
    axios(config)
      .then((response) => {
        callback(null, response.data);
      })
      .catch((error) => {
        callback(error, null);
      });
  }
};

export default NetworkApi;
